export default "__VITE_ASSET__B35H6PBl__"